import { createFileRoute } from "@tanstack/react-router";

import { seo } from "@/lib/seo";
import { assertDraftRouteVisible } from "@/lib/draft-routes";
import { PagePlaceholder } from "@/components/site/PagePlaceholder";

export const Route = createFileRoute("/_site/guides/sba-loan-guide")({
  // Draft route: 404s on the live domain, renders normally elsewhere. See src/lib/draft-routes.ts.
  beforeLoad: assertDraftRouteVisible,
  head: () =>
    seo({
      title: "SBA Loan Preparation Guide",
      description: "What lenders look for in an SBA application and how to assemble the package.",
      path: "/guides/sba-loan-guide",
      noindex: true,
    }),
  component: Page,
});

function Page() {
  return <PagePlaceholder title={"SBA loan preparation guide"} intro={"[SUPPLY: guide content]"} />;
}
